import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=722ab351&scoped=true"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"
import style0 from "./index1.vue?vue&type=style&index=0&id=722ab351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ab351",
  null
  
)

export default component.exports